import { useMutation } from "@tanstack/react-query";
import {
  AFLViagsService,
  IViagsLeaveInfo,
} from "../../../../../services/viags/application-for-leave.service";
import { notification } from "antd";

interface IVariables {
  employeeId: string;
}

export const useSearchViagsUser = () => {
  const { mutate, ...restMutation } = useMutation({
    mutationFn: (vars: IVariables) => {
      return AFLViagsService.getLeaveInfo(vars.employeeId);
    },
  });

  const searchViagsUser = (
    vars: IVariables,
    options?: { onSuccess?: (res: IViagsLeaveInfo[]) => void }
  ) => {
    mutate(vars, {
      onSuccess(response) {
        if (!response) {
          notification.warning({
            message: "Không tìm thấy thông tin",
            description: "Vui lòng kiểm tra lại Mã nhân viên",
          });
          return;
        }
        if (options?.onSuccess) {
          options.onSuccess(response);
        }
      },
      onError() {
        notification.error({
          message: "Có lỗi xảy ra",
          description: "Vui lòng thử lại",
        });
      },
    });
  };

  return { searchViagsUser, ...restMutation };
};
